import { useState, type ReactNode } from "react";
import AdminSidebar from "./AdminSidebar";
import { useAdminSession } from "./AdminSessionContext";
import { ROLE_META } from "../adminConfig";

interface AdminLayoutProps {
  children: ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { role, username } = useAdminSession();
  const displayName = username || "内部员工";
  const roleMeta = role ? ROLE_META[role] : null;

  return (
    <div className="min-h-screen bg-background-100">
      <div className="flex min-h-screen">
        <aside className="hidden w-60 shrink-0 border-r border-background-200 md:block">
          <div className="sticky top-0 h-screen">
            <AdminSidebar />
          </div>
        </aside>

        <div className="flex min-w-0 flex-1 flex-col">
          <header className="sticky top-0 z-30 flex h-16 items-center justify-between gap-4 border-b border-background-200 bg-background-50/95 px-4 backdrop-blur md:px-6">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setMobileOpen(true)}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
                aria-label="打开菜单"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
              <span className="font-heading text-base font-semibold text-foreground-950">
                锦伴金秋 · 内部管理系统
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="hidden items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-600 sm:flex">
                <i className="ri-user-line text-primary-500"></i>
                {displayName}
              </span>
              {roleMeta && (
                <span
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium ${roleMeta.badge}`}
                >
                  <i className={`${roleMeta.icon} text-sm`}></i>
                  {roleMeta.label}
                </span>
              )}
            </div>
          </header>

          <main className="flex-1 px-4 py-6 md:px-6 lg:px-8">{children}</main>
        </div>
      </div>

      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className="absolute inset-0 bg-foreground-950/40"
            onClick={() => setMobileOpen(false)}
          ></div>
          <div className="absolute left-0 top-0 h-full w-64 border-r border-background-200">
            <AdminSidebar onNavigate={() => setMobileOpen(false)} />
          </div>
        </div>
      )}
    </div>
  );
}